import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import DashboardIcon from "@mui/icons-material/Dashboard";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import BusinessIcon from "@mui/icons-material/Business";
import FiberNewIcon from "@mui/icons-material/FiberNew";

function getNavValue(pathname) {
  if (pathname.startsWith("/dashboard")) return "/dashboard";
  if (pathname.startsWith("/contacts/new")) return "/contacts/new";
  if (pathname.startsWith("/contacts")) return "/contacts";
  if (pathname.startsWith("/companies")) return "/companies";
  return "/dashboard";
}

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const value = useMemo(() => getNavValue(location.pathname), [location.pathname]);

  return (
    <div className="mobile-bottom-nav">
      <BottomNavigation
        value={value}
        onChange={(_, newValue) => {
          if (!newValue) return;
          navigate(newValue);
        }}
        showLabels={false}
      >
        <BottomNavigationAction
          value="/dashboard"
          icon={<DashboardIcon />}
          aria-label="Dashboard"
        />
        <BottomNavigationAction
          value="/contacts"
          icon={<RecentActorsIcon />}
          aria-label="Contacts"
        />
        <BottomNavigationAction
          value="/contacts/new"
          icon={<FiberNewIcon />}
          aria-label="New Contacts"
        />
        <BottomNavigationAction
          value="/companies"
          icon={<BusinessIcon />}
          aria-label="Companies"
        />
      </BottomNavigation>
    </div>
  );
}


